(ns graph-ui.web.lazy
  "WHAT A HIDDEN WIDGET HAS NOT ASKED FOR YET — the client half of a bind that
   declares `:load :on-visible` (PLAN-ikc-v3-033-01 step 4a).

   THE SERVER NO LONGER SENDS SUCH A VALUE. reader-v3's reply held 64 binds on
   2026-09-19, and about 40 of them were behind a closed tab or a folded
   collapsible. Each one was read, sent and held for a widget with no pixel. The
   snapshot now carries what the first paint draws, and the widget that finally
   draws asks for the rest.

   WHY AN ATOM AND NOT A DISPATCH FROM THE RENDERER. A render must not have side
   effects, and graph-ui.web.render cannot require graph-ui.web.core — the
   dependency runs the other way. So a widget that mounts with no value RECORDS
   that it wants one, and core watches this atom and does the reads. It is the
   graph-ui.web.busy and graph-ui.web.draft pattern, for the same reason.

   STALL, NEVER VANISH. A widget waiting for its value draws a waiting mark, and
   never an empty list. An empty answer and an answer that has not arrived look
   identical on a screen, and a reader believes the first one."
  (:require [reagent.core :as r]))

;; @feature F-platform-v0-022-01-a-flow-has-a-budget
;; @adr ADR-graph-ui-v0-003-01-ui-from-formal-description

(defonce ^:private wanted
  ;; #{[source args]} — the pairs a drawn widget needs and does not have.
  (r/atom #{}))

(defn want!
  "Record that a widget has drawn and has no value for this pair.

   IDEMPOTENT, because a render happens many times and a mount can repeat. The
   set is the whole guard: a pair already in it adds nothing, and `taken!`
   removes it once the read is on its way."
  [source args]
  (swap! wanted conj [source args])
  nil)

(defn pending
  "The pairs no read has been sent for yet, as [[source args] …]."
  []
  (vec @wanted))

(defn taken!
  "Forget a pair, once a read for it has been dispatched."
  [source args]
  (swap! wanted disj [source args])
  nil)

(defn watch!
  "Call `f` with [[source args] …] whenever a widget asks for something new.
   core installs one of these. A second call replaces the first."
  [f]
  (remove-watch wanted ::reader)
  (add-watch wanted ::reader
             (fn [_ _ old new]
               (let [fresh (remove (set old) new)]
                 (when (seq fresh) (f (vec fresh))))))
  nil)
